var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanelInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M-18752-9906.259a6.959 6.959 0 0 1-4 1.259 7.009 7.009 0 0 1-7-7 7.005 7.005 0 0 1 7-7 6.958 6.958 0 0 1 4 1.258 6.965 6.965 0 0 1 4-1.258 7 7 0 0 1 7 7 7.008 7.008 0 0 1-7 7 6.966 6.966 0 0 1-4-1.259zm4-.742a5.006 5.006 0 0 0 5-5 5 5 0 0 0-5-5 4.972 4.972 0 0 0-2.5.672 6.967 6.967 0 0 1 1.5 4.324 6.97 6.97 0 0 1-1.5 4.328 4.97 4.97 0 0 0 2.5.677zm-13-5a5.008 5.008 0 0 0 5 5 4.97 4.97 0 0 0 2.5-.672 6.972 6.972 0 0 1-1.5-4.329 6.952 6.952 0 0 1 1.5-4.326 4.978 4.978 0 0 0-2.5-.67 5 5 0 0 0-5 4.998zm8 0a4.968 4.968 0 0 0 1 3 4.981 4.981 0 0 0 1-3 4.973 4.973 0 0 0-1-3 4.96 4.96 0 0 0-1 3.001z",
    opacity: 0.3,
    transform: "translate(18764 9924.001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "colorable",
    d: "M0 5.745A6.991 6.991 0 0 1 3 0a6.991 6.991 0 0 1 3 5.745 6.991 6.991 0 0 1-3 5.745 6.991 6.991 0 0 1-3-5.745z",
    transform: "translate(9 6.255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanelInterface);
export default __webpack_public_path__ + "static/media/left-panel-interface.bbe522ee47bafeca9c1fd291d9cb9942.svg";
export { ForwardRef as ReactComponent };